<div class="filter-container filter-label">
    <div *ngIf="false" class="filter-description">
        <span class="field-description">{{ repeaterfieldDescription() }}</span>
    </div>

    <div class="filter-content">
        <div class="filter-toolbar">
            <button type="button" class="btn btn-light" aria-label="Refresh filter options"
                title="Load the criteria for your search" [disabled]="this.loading" (click)="refresh()">{{this.getLoadLabel()}}</button>
            <button type="button" class="btn btn-light" aria-label="Clear selected option"
                title="Clear selected options" [disabled]="this.loading" (click)="clear()">Clear</button>
            <button *ngIf="showCode" type="button" [disabled]="this.loading" class="btn btn-light"
                title="Sort alphabetically" (click)="order(allowedOrderField())"><span
                    class="bi bi-sort-alpha-down"></span>&nbsp;{{allowedOrderField()}}</button>
            <button type="button" class="btn btn-light" aria-label="Add a new condition for the selected filter"
                title="Add a new condition for the selected filter" (click)="add()">New</button>
            <button [disabled]="repeaterLength()<2" type="button" class="btn btn-light"
                aria-label="Each repeat of the control is removed" title="Remove a condition from the selected filter"
                (click)="remove()">Remove</button>
        </div>

        <div *ngIf="this.loading">
            <app-loading customPositonClass="wrap-container-centered" loadingMessage="Loading Filter"/>
        </div>

        <div *ngIf="!this.loading">
            <div class="two-columns">
                <select name="operator" class="form-select" (change)="setOperator($event)" [multiple]="false"
                    type="text" [disabled]="this.operatorDisabled">
                    <option value="eq" [selected]="this.formControl.parent!.get('operator')?.value === 'eq'"
                        title="Any column content has the exact provided value">Match</option>
                    <option value="sw" [selected]="this.formControl.parent!.get('operator')?.value === 'sw'"
                        title="Any column content starts with the provided value">Starts with</option>
                    <option value="cn" [selected]="this.formControl.parent!.get('operator')?.value === 'cn'"
                        title="Any column content includes the provided value">Contains</option>
                    <option value="ew" [selected]="this.formControl.parent!.get('operator')?.value === 'ew'"
                        title="Any column content ends with the provided value">Ends with</option>
                    <option value="in" [selected]="this.formControl.parent!.get('operator')?.value === 'in'"
                        title="Any column content has the exact value(s) provided and separated by vertical bar symbol">
                        With</option>
                </select>
                <input class="form-control" [placeholder]="props['searchPlaceholder'] || 'Write and Press Enter'"
                    [(ngModel)]="this.queryControl" (keyup)="onKeyUp()" (keydown.enter)="onEnter()" (paste)="onPaste($event)" type="text" />
            </div>
            <select class="form-control" [formControl]="formControl" [multiple]="props['multiple']"
                [size]="props['size']" type="text">
                <option *ngFor="let opt of datasource; trackBy: trackByCode" [ngValue]="opt.code">
                    {{ opt.name }}
                </option>
            </select>
        </div>
    </div>
</div>